// src/auth/LoginModal.jsx
// Modal shell around the shared OTP form. Rendered once by AuthProvider.
import React, { useEffect } from "react";
import OtpForm from "./OtpForm";
import "./LoginModal.css";

function LoginModal({ onClose }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div
      className="lm-backdrop"
      onClick={handleBackdropClick}
      role="presentation"
    >
      <div
        className="lm-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="lm-title"
      >
        <button
          type="button"
          className="lm-close"
          onClick={onClose}
          aria-label="Close sign-in dialog"
        >
          <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
            <path
              d="M6 6l12 12M18 6L6 18"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>
        <h2 className="lm-title" id="lm-title">
          Sign in
        </h2>
        <OtpForm onSuccess={onClose} />
      </div>
    </div>
  );
}

export default LoginModal;
